import {useEventBus} from "../../../assets-dev/ts/modules/use-event-bus";

export class ComponentPeopleList {
    private readonly itemClass = '.hd-people-list__item';
    private readonly itemActiveClass = 'active';
    private readonly itemActivationElementClass = '.hd-people-list__item-link';
    private readonly itemCloseClass = '.hd-person__close';
    private readonly personClass = '.hd-person';

    private bodyEl: HTMLElement;
    private el: HTMLElement;
    private items: HTMLElement[];
    private personItems: HTMLElement[];
    private activeItemIndex: number | undefined;

    private itemToggleFns: any[] = [];
    private itemCloseFns: any[] = [];

    private closeClearTimeoutId;
    private openTimeoutId;

    constructor(el: HTMLElement) {
        this.el = el;
        this.bodyEl = document.body;
        this.items = <HTMLElement[]>Array.from(el.querySelectorAll(this.itemClass));
        this.personItems = <HTMLElement[]>Array.from(el.querySelectorAll(this.personClass));
        this.activeItemIndex = this.items.findIndex(item => item.classList.contains(this.itemActiveClass));
    }

    public onInit() {
        this.initToggles();
        this.initCloses();
        this.open();
    }

    public onDestroy() {
        this.itemToggleFns.forEach((e) => {
            e.el.removeEventListener(e.event, e.fn);
        });
        this.itemToggleFns = [];
        this.itemCloseFns.forEach((e) => {
            e.el.removeEventListener(e.event, e.fn);
        });
        this.itemCloseFns = [];
    }

    private initToggles() {
        this.items.forEach((item, index) => {
            const el = item.querySelector(this.itemActivationElementClass);
            if (el) {
                const e = {
                    el,
                    event: 'click',
                    fn: this.toggleIndex.bind(this, index),
                }
                this.itemToggleFns.push(e);
                e.el.addEventListener(e.event, e.fn);
            }
        });
    }

    private initCloses() {
        this.personItems.forEach(item => {
            const el = item.querySelector(this.itemCloseClass);
            if (el) {
                const e = {
                    el,
                    event: 'click',
                    fn: this.closeExpanded.bind(this),
                }
                this.itemCloseFns.push(e);
                e.el.addEventListener(e.event, e.fn);
            }
        });
    }

    private open() {
        if (this.activeItemIndex == null) {
            return;
        }
        clearTimeout(this.closeClearTimeoutId);
        clearTimeout(this.openTimeoutId);
        const activeItem = this.items[this.activeItemIndex];
        const activePerson = this.personItems[this.activeItemIndex];
        if (!activeItem || !activePerson) {
            return;
        }
        this.bodyEl.style.overflow = 'hidden';
        if (activePerson) {
            activePerson.style.display = 'block';
        }
        this.openTimeoutId = setTimeout(() => {
            activePerson.classList.add('open');
        }, 10);
    }

    private toggleIndex(index, event) {
        console.log('toggleIndex', index, event);
        // event.preventDefault();
        // this.activeItemIndex = this.activeItemIndex === index ? null : index;
        // this.open();
    }

    private closeExpanded(event?: any) {
        clearTimeout(this.closeClearTimeoutId);
        clearTimeout(this.openTimeoutId);
        if (event != null) {
            event.preventDefault();
        }
        this.bodyEl.style.overflow = 'auto';
        if (this.activeItemIndex == null) {
            return;
        }
        const activePerson = this.personItems[this.activeItemIndex];
        if (!activePerson) {
            return;
        }

        activePerson.classList.remove('open');
        if (activePerson) {
            activePerson.style.display = 'block';
        }
        this.closeClearTimeoutId = setTimeout(() => {
            if (activePerson) {
                activePerson.style.display = '';
            }
        }, 350);

        this.items.filter(item => item.classList.contains('active')).forEach(item => {
            item.classList.remove('active');
        });
        this.personItems.filter(item => item.classList.contains('open')).forEach(item => {
            item.classList.remove('open');
        });
        this.activeItemIndex = undefined;
    }
}

export function useComponentPeopleList() {
    useEventBus('hd-people-list', ComponentPeopleList);
}